"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_control_options_model_1 = require("./chart-control-options.model");
class SerpentineChartControlOptionsModel extends chart_control_options_model_1.ChartControlOptions {
    constructor(options) {
        super(options);
        options.levelCount && (this.levelCount = options.levelCount);
        options.orientation && (this.orientation = options.orientation);
        options.legendType && (this.legendType = options.legendType);
        options.eventBulletType && (this.eventBulletType = options.eventBulletType);
        options.hasEventIcon && (this.hasEventIcon = options.hasEventIcon);
    }
}
exports.SerpentineChartControlOptionsModel = SerpentineChartControlOptionsModel;
//# sourceMappingURL=serpentine-chart-control-options.model.js.map